import React from "react";
import { Button } from "@opendate-app/setlist";
import BreadcrumbChevron from "../../shared/components/BreadcrumbChevron";
import { useSeriesEditContext } from "../SeriesEditApp";

const timeOf = (date) => date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });

const AutoSaveStatus = ({ enabled, published, autoSave }) => {
  if (published) {
    return (
      <span className="series-autosave-status series-autosave-off">
        Auto-save is off for published series. Use Save Changes to keep your edits.
      </span>
    );
  }
  if (!enabled) return null;

  const text = {
    saving: "Saving draft…",
    saved: autoSave.savedAt ? `Draft saved · ${timeOf(autoSave.savedAt)}` : "Draft saved",
    error: autoSave.error ? `Couldn't auto-save: ${autoSave.error}` : "Couldn't auto-save. Your changes are not saved yet.",
  }[autoSave.status] || "Drafts save automatically";

  return (
    <span
      className={`series-autosave-status series-autosave-${autoSave.status}`}
      role="status"
      aria-live="polite"
    >
      {text}
    </span>
  );
};

const SeriesEditHeader = () => {
  const { form, indexUrl, showUrl, save, saving, manualSaving, canSave, autoSave, autoSaveEnabled,
    published } = useSeriesEditContext();
  return (
    <div className="series-edit-header">
      <nav aria-label="breadcrumb" className="d-flex align-items-center flex-wrap series-edit-breadcrumb">
        <a href="/dashboard" className="settings-breadcrumb-link" aria-label="Calendar"><i className="fal fa-home" /></a>
        <BreadcrumbChevron />
        <a href={indexUrl || showUrl} className="settings-breadcrumb-link">Series</a>
        <BreadcrumbChevron />
        <span className="settings-breadcrumb-current">Edit: {form.name}</span>
      </nav>
      <div className="d-flex align-items-center justify-content-between series-edit-title-row">
        <div>
          <h1 className="series-edit-title">Edit Series</h1>
          <div className="series-edit-subtitle">{form.name}</div>
        </div>
        <div className="d-flex align-items-center series-edit-actions">
          <AutoSaveStatus
            enabled={autoSaveEnabled}
            published={published}
            autoSave={autoSave}
          />
          {saving ? (
            <Button variant="secondary" disabled>
              Cancel
            </Button>
          ) : (
            <Button variant="secondary" as="a" href={showUrl}>
              Cancel
            </Button>
          )}
          <Button variant="primary" onClick={save} disabled={saving || !canSave}>
            {manualSaving ? "Saving…" : "Save Changes"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SeriesEditHeader;
